import { RequiredTranslationsTemplate } from '.'

const cs: RequiredTranslationsTemplate = {
  meta: {
    localeName: 'Česky',
  },
  home: {
    title: 'STAŽENÍ VÝROBKU ROCKRIDER XC500 S',
    description:
      'Děkujeme za důvěru, kterou jste nám projevili zakoupením horského kola ROCKRIDER XC500 S. Zjistili jsme potenciální riziko závady vidlice. Závada se týká pouze některých sérií. Zadáním 6 posledních číslic sériového čísla Vašeho kola a zjistíte, zda se tato závada týká i Vašeho kola.',
    form: {
      title: 'Zadejte následující informace:',
      fields: {
        serialNumber: 'Sériové číslo:',
        serialNumberFamily: 'N° série (début)',
        firstName: 'Jméno',
        lastName: 'Příjmení',
        email: 'E-mail',
        phone: 'Telefonní číslo',
        country: 'Země',
        submit: 'Potvrdit',
        choose: 'Vybrat...',
      },
      errors: {
        requiredField: 'Toto pole je povinné',
        unknownSerialNumber: 'Neznámé sériové číslo',
        provide6Numbers: 'Upozorňujeme, že je vyžadováno 6 číslic',
      },
      confirmations: {
        good: {
          title: 'Vašeho kola se to netýká',
          p1: 'Závada se Vašeho kola netýká a můžete jej nadále bezpečně používat.',
          p2: 'Omlouváme se za vzniklé nepříjemnosti.',
          p3: 'Se sportovním pozdravem,',
          p4: 'Tým Decathlon',
        },
        defective: {
          title: 'Závada se bohužel Vašeho kola týká.',
          p1: 'Žádáme Vás, abyste kolo nadále nepoužívali a navštívili nejbližší prodejnu Decathlon, kde Vám vidlici v oddělení servisu vyměníme.',
          p2: 'Vezměte prosím na vědomí, že výměna může trvat několik dní. Uděláme však vše, co bude v našich silách, aby byla doba co nejkratší. Obraťte se přímo na servis Vaší oblíbené prodejny, kde se dozvíte dobu potřebnou pro opravu.',
          p3: 'Zde najdete nejbližší servis:',
          decathlonLocatorLink: 'https://www.decathlon.fr/store-locator',
          p4: 'Níže naleznete dokument, který předložte na oddělení servisu:',
          p5: 'Pro více informací kontaktujte naše zákaznické centrum: +420 228 800 008 od pondělí do pátku od 9:00 a 19:00 hodin, o víkendu od 9:00 do 17:00 hodin.',
        },
      },
    },
    findTheSerialNumber: {
      title: 'Kde se nachází sériové číslo:',
      description: 'Sériové číslo je umístěno na vidlici',
    },
  },
}

export default cs
